import { Box, Table, TableRow, TopBar } from '@sam/components';
import { TableHeader, TableKey } from '@sam/components/src/Table/Table.types';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { updateSchambeckUserTableConfig, useData } from 'shared';
import { Right } from 'shared/src/userRole/UserRole.types';
import { NotAllowed } from '../../components/NotAllowed';
import { useUser } from '../../components/UserContext';
import { convertPdlIntoTableEntries } from '../../utils/pdl/Pdl.utils';
import { isUserAllowedToDo } from '../../utils/user/User.utils';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

const PdlOverviewPage: React.FC = () => {
  const { user, axios, updateContextUser } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [filterValue, setFilterValue] = useState<string>('');

  const { data: allPdls } = useData('PDL_ALL', {
    config: { fallbackData: [] },
  });

  /**
   * Helper Method to convert pdls to tableRows
   */
  const rows: TableRow[] = useMemo(
    (): TableRow[] => convertPdlIntoTableEntries(user.right, allPdls, navigate),
    [allPdls, navigate, user.right],
  );

  return isUserAllowedToDo(user.right, Right.PDL_OVERVIEW) ? (
    <>
      <TopBar title={t('pages.pdl.overview.headline')} onSearch={setFilterValue}>
        {isUserAllowedToDo(user.right, Right.PDL_CREATE) && (
          <IconComponent type={IconType.ADD} onClick={() => navigate('edit')} />
        )}
      </TopBar>
      <Box>
        <Table
          tableConfig={user.tableConfig?.get(TableKey.PDL_OVERVIEW)}
          updateTableConfig={(updatedHeader) => {
            updateSchambeckUserTableConfig(axios, user, TableKey.PDL_OVERVIEW, updatedHeader).then(
              (updatedUser) => updatedUser && updateContextUser(updatedUser),
            );
          }}
          filterValue={filterValue}
          rows={rows}
          header={
            t('pages.pdl.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </>
  ) : (
    <NotAllowed neccessaryRight={Right.PDL_OVERVIEW} />
  );
};
export default PdlOverviewPage;
